import { jsx as s } from "react/jsx-runtime";
import { c as n } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
const c = ({
  className: r,
  variant: a = "text",
  width: d,
  height: t,
  ...e
}) => /* @__PURE__ */ s(
  "div",
  {
    className: n(
      "animate-pulse bg-muted",
      {
        text: "h-4 w-full rounded-[var(--ds-radius-sm)]",
        circular: "rounded-[var(--ds-radius-full)]",
        rectangular: "rounded-none",
        rounded: "rounded-[var(--ds-radius-md)]"
      }[a],
      r
    ),
    style: {
      width: d,
      height: t
    },
    ...e
  }
);
export {
  c as S
};
